import { combineReducers } from '@reduxjs/toolkit';

import tabs from './tabs';
import vatChecked from './vatChecked';
import selectedGroupOffer from './selectedGroupOffer';
import appointmentBookingModal from './appointmentBookingModal';
import interventionUpdateModalData from './interventionUpdateModalData';
import isInterventionUpdateModalOpen from './isInterventionUpdateModalOpen';

/**
 * @typedef {{
 *  tabs: import('./tabs').TabsState,
 *  vatChecked: import('./vatChecked').VatCheckedState,
 *  selectedGroupOffer: import('./selectedGroupOffer').SelectedGroupOfferState,
 *  appointmentBookingModal: import('./appointmentBookingModal').isAppointmentBookingModalOpen,
 *  interventionUpdateModalData: import('./interventionUpdateModalData').interventionUpdateModalDataState,
 *  isInterventionUpdateModalOpen: import('./isInterventionUpdateModalOpen').IsInterventionUpdateModalOpenState,
 * }} UIState
 */

export default combineReducers({
  tabs,
  vatChecked,
  selectedGroupOffer,
  appointmentBookingModal,
  interventionUpdateModalData,
  isInterventionUpdateModalOpen,
});
